//------------------------------------------------------------------------
// Autosubmit form data on checkbox or radio change
//------------------------------------------------------------------------

const init = () => {
  const forms = document.querySelectorAll("form[data-autosubmit]");

  // Find forms that should auto-submit
  forms.forEach((form) => {
    const selects = form.querySelectorAll("select");

    if (selects.length) {
      // Submit form when selects are changed
      selects.forEach((select) => {
        select.addEventListener("change", function () {
          form.submit();
        });
      });
    }
  });
};

// Init on initial page load
init();

